import { createFileRoute, redirect } from '@tanstack/react-router'

import { getLocalStorageItem } from '@/core/utils/localStorage/getLocalStorageItem'
import { tryCatch } from '@/core/utils/tryCatch'
import { GrowthMapPageStartAssessment } from '@/growth-map/components/GrowthMapPageStartAssessment/GrowthMapPageStartAssessment'
import { skillsCurrentOptions } from '@/growth-map/queries/useSkillsCurrent'

export const Route = createFileRoute('/_learning/growth-map/')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const [, currentSkill] = await tryCatch(
      queryClient.ensureQueryData(skillsCurrentOptions()),
    )

    if (currentSkill) {
      throw redirect({
        to: '/growth-map/$skillSlug',
        params: { skillSlug: currentSkill.slug },
        search: {
          show_completed_courses: getLocalStorageItem(
            'growth-map-show-completed-courses',
          ),
        },
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <GrowthMapPageStartAssessment />
}
